import {
	Avatar,
	Box,
	Card,
	Checkbox,
	Fab,
	Grid,
	Hidden,
	Icon,
	IconButton,
	styled,
	useTheme,
} from '@mui/material';
import { Span } from 'app/components/Typography';
import { format } from 'date-fns';
import { Fragment } from 'react';
import { useSelector } from 'react-redux';

const ProjectName = styled(Span)(({ theme }) => ({
	marginLeft: 24,
	fontWeight: '500',
	[theme.breakpoints.down('sm')]: { marginLeft: 4 },
}));

const StarOutline = styled(Fab)(() => ({
	marginLeft: 0,
	boxShadow: 'none',
	background: '#08ad6c !important',
	backgroundColor: 'rgba(9, 182, 109, 1) !important',
}));

const DateRange = styled(Fab)(({ theme }) => ({
	marginLeft: 0,
	boxShadow: 'none',
	color: 'white !important',
	background: `${theme.palette.error.main} !important`,
}));

const StyledAvatar = styled(Avatar)(() => ({
	width: '32px !important',
	height: '32px !important',
}));

const RowCards = () => {
	const { palette } = useTheme();
	const { booking } = useSelector((state) => state.home);
	const textMuted = palette.text.secondary;

	return (
		<>
			{booking?.result?.length > 0 &&
				booking?.result?.map((i, index) =>
					index < 5 ? (
						<Fragment key={index}>
							<Card sx={{ py: 1, px: 2 }} className='project-card'>
								<Grid container alignItems='center'>
									<Grid item md={2} xs={2}>
										<Box display='flex' alignItems='center'>
											{i.orderId}
										</Box>
									</Grid>
									{/* <Grid item md={3} xs={2}>
										<Box color={textMuted}>{i.bookingRefrence}</Box>
									</Grid> */}

									<Hidden smDown>
										<Grid item xs={2}>
											<Box
												display='flex'
												position='relative'
												marginLeft='-0.875rem !important'>
												{i.bookingRefrence}
											</Box>
										</Grid>
									</Hidden>
									<Grid item md={3} xs={3}>
										<Box color={textMuted}>{i.dob}</Box>
									</Grid>
									<Grid item xs={2}>
										<Box display='flex' justifyContent='flex-end'>
											{i.bookingStatus}
										</Box>
									</Grid>
									<Grid item xs={2}>
										<Box display='flex' justifyContent='flex-end'>
											{i.baseFare}
										</Box>
									</Grid>
									<Grid item xs={1}>
										<Box display='flex' justifyContent='flex-end'>
											<IconButton>
												<Icon>more_vert</Icon>
											</IconButton>
										</Box>
									</Grid>
								</Grid>
							</Card>
							<Box py={1} />
						</Fragment>
					) : (
						<></>
					)
				)}
		</>
	);
};

export default RowCards;
